<template>
  <div>
    <v-container
      style="padding-top: 0px"
      :class="$vuetify.breakpoint.xlOnly ? 'container-mypad' : ''"
    >
      <v-row>
        <v-col cols="12" style="padding:8px 8px 0px 8px">
          <v-row>
            <v-col cols="7" xs="12">
              <Navigation
                :type="'strategies'"
                :myOwn="myOwn"
                :username="user.username"
                :avatar="user.avatar"
                :level1="strategy.name"
              />
            </v-col>
            <v-col cols="5" xs="12">
              <Submenu @view="changeView"/>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>


    
    <v-container v-if="view == 0"
      style="padding-top: 0px"
      :class="$vuetify.breakpoint.xlOnly ? 'container-mypad' : ''"
    >
      <v-row>
        <v-col cols="3" style="padding:8px 8px 0px 8px">
          <v-card class flat>
            <MiniGauge :data="stats.successRate" />
          </v-card>
        </v-col>
        <v-col cols="3" style="padding:8px 8px 0px 8px">
          <v-card class flat>
            <MiniWeek :data="stats.weekDays" />
          </v-card>
        </v-col>
        <v-col cols="3" style="padding:8px 8px 0px 8px">
          <v-card class flat>
            <MiniSeven :inverse="false" :data="stats.lastSeven" />
          </v-card>
        </v-col>
        <v-col cols="3" style="padding:8px 8px 0px 8px">
          <v-card flat>
            <MiniEquity source="direct" :data="stats.equity" />
          </v-card>
        </v-col>
        <v-col cols="3" style="padding:8px 8px 0px 8px">
          <v-card flat>
            <MiniHours source="direct" :data="stats.entryHours" />
          </v-card>
        </v-col>
      </v-row>

      <v-row>
        <v-col lg="5" sm="12" style="padding:8px 8px 0px 8px">
          <v-col cols="12" class="mb-4 mt-2">
            <Description :editable="myOwn" :value="strategy.description" parentType="strategies" @update="updateDescription" />
          </v-col>
          <v-col cols="12" class="mb-4">
            <CheckList :editable="myOwn"  :value="strategy._checkList" :data="strategy" parentType="Strategies" @update="updateChecklist" @removeChecklist="removeChecklist" />
          </v-col>
          <v-col cols="12" class="mb-4">
            <Gallery :editable="myOwn"  :items="strategy._images" parentType="Strategies" @update="updateGallery" />
          </v-col>
        </v-col>
        <v-col lg="7" sm="12" style="padding:8px 8px 0px 8px">
          <v-col v-if="myOwn" cols="12" class="mt-2">
            <TimelineInput
              :parentId="this.$route.params.id"
              parentType="Strategies"
              @updateMessage="updateMessage"
              @updateImage="updateImage"
              
            />
          </v-col>
          <v-col cols="12">
            <Timeline :items="strategy._log" parentType="Strategies" storeKey="StrategyDetail" @hideLog="hideLog" />
          </v-col>
        </v-col>
      </v-row>
    </v-container>







     <v-container v-if="view == 1"
      style="padding-top: 0px"
      :class="$vuetify.breakpoint.xlOnly ? 'container-mypad' : ''"
    >
  <v-row>
     <v-col cols="12" style="padding:8px 8px 0px 8px">
       <v-card flat>
    <Tradelist :data="strategy._trades" />
    </v-card>
     </v-col>
    </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";
import Navigation from "@/components/navigation.vue";
import Submenu from "@/components/objectComponents/submenu.vue";
import Description from "@/components/objectComponents/description.vue";
import CheckList from "@/components/objectComponents/checkList.vue";
import TimelineInput from "@/components/timeline/dragdropBox.vue";
import Gallery from "@/components/objectComponents/gallery.vue";
import Timeline from "@/components/timeline/timeline.vue";
import MiniSeven from "@/components/minicharts_v2/miniSeven.vue";
import MiniWeek from "@/components/minicharts_v2/miniWeek.vue";
import MiniGauge from "@/components/minicharts_v2/miniGauge.vue";
import MiniEquity from "@/components/minicharts_v2/miniEquity.vue";
import Tradelist from "@/components/tradelist.vue";
import MiniHours from "@/components/minicharts_v2/miniHours.vue";

export default {
  name: "StrategyDetail",

  components: {
    Tradelist,
    Navigation,
    Submenu,
    Description,
    TimelineInput,
    Gallery,
    Timeline,
    MiniGauge,
    MiniWeek,
    MiniEquity,
    MiniSeven,
    CheckList,
    MiniHours
  },

  data() {
    return {
      view: 0,
      myOwn: false,
      loaded: false,

      stats: {
        successRate: 0,
        weekDays: [0, 0, 0, 0, 0, 0, 0],
        entryHours: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        exitHours: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        lastSeven: [],
        equity: [0],
      },

      loadingUpload: false,

    };
  },

  created() {
    if (this.username == this.$route.params.name) {
      this.myOwn = true;
    }
    

  },
  computed: {
    ...mapGetters(["username", "timezone"])
  },
  asyncComputed: {
    strategy: {
      get() {
        return new Promise((resolve, reject) => {
          axios
            .post("https://tradeinpool.com:3001/api/request/strategies/", {
              method: "detail",
              documentId: this.$route.params.id
            })
            .then(response => {
              // setTimeout(() => {
              this.loaded = true;
              resolve(response.data);
              this.stats = this.$statistics(response.data._trades)
              // },1000)
            })
            .catch(err => {
              reject(err);
            });
        });
      },
      default: {}
    },
    user: {
      get() {
        //if (this.username != this.$route.params.name) {
        return new Promise((resolve, reject) => {
          axios
            .post("https://tradeinpool.com:3001/api/request/user/", {
              method: "basic",
              name: this.$route.params.name
            })
            .then(response => {
              resolve(response.data);
            })
            .catch(err => {
              reject(err);
            });
        });
        //}
      },
      default: { username: "user", avatar: null }
    }
  },
  methods: {
    updateDescription(data){
      this.strategy.description = data.new
      this.strategy._log.unshift(data.response)
    },
    updateChecklist(data){
      data.forEach(item =>{
        this.strategy[item.key].unshift(item.value)
      })
    },
    updateGallery(data){
      this.strategy._log.unshift(data.push[0].value)
      this.strategy._images.forEach((img,index) =>{
        if(img._id == data.remove[0].value){
          this.strategy._images.splice(index,1)
        }
      })
    },
    updateMessage(data){
      this.strategy._log.unshift(data.push[0].value)
    },
    updateImage(data){
      data.forEach(item =>{
        this.strategy[item.key].unshift(item.value)
      })
    },
    hideLog(data){
      this.strategy._log.forEach((log,index) =>{
        if(log._id == data){
          this.strategy._log.splice(index,1)
        }
      })
    },
    removeChecklist(data){
      this.strategy._log.unshift(data.push[0].value)
      this.strategy._checkList.forEach((check,index) =>{
        if(check._id == data.remove[0].value){
          this.strategy._checkList.splice(index,1)
        }
      })
    },
    changeView(data){
      this.view = data
    }
  }
};
</script>

<style scoped>
.stat-value {
  font-size: 35px;
  height: 50px;
  margin-top: 10px;
}

.stat-name {
  font-size: 16px;
  font-weight: bold;
  margin-top: 0px;
  color: #b6c1cb;
  margin-bottom: 10px;
}

.arrow-back {
  top: 0px;
  position: absolute;
  left: -100px;
  padding-top: 5px;
  text-align: center;
  height: 60px;
  width: 60px;
  background-color: rgba(0, 0, 0, 0.3);
  transition: 0.5s;
  cursor: pointer;
}
.arrow-back-show {
  left: 0px;
}
.arrow-back:hover {
  text-align: left;
}
.title-move {
  margin-left: 60px;
}
.trans {
  transition: 0.5s;
}
.v-expansion-panels {
  background-color: white !important;
}

.myChip {
  float: left;
  background: #4dbac0 !important;
  width: auto;
  height: 34px;
  font-size: 24px;
  border-radius: 17px;
}

.min-flexheight {
  min-height: 250px;
}
</style>